import { type HTMLChakraProps, useStyleConfig } from '@chakra-ui/react';
import { forwardRef } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';
import { useCallback } from 'react';

import { ArrowLeft } from '@frontend/components';

import { useConversationContext } from '../ConversationContext';
import { useConversationStyles } from '../useConversationStyles';

export type ConversationScrollButtonProps = Omit<
  HTMLChakraProps<'button'>,
  'children'
>;

/**
 * Scroll button that appears when the user is not at the bottom of the conversation.
 * Clicking it scrolls smoothly to the bottom.
 */
export const ConversationScrollButton: React.FC<ConversationScrollButtonProps> =
  forwardRef<ConversationScrollButtonProps, 'button'>(
    ({ children, ...props }, ref) => {
      const { scrollButton } = useConversationStyles();
      const iconButton = useStyleConfig('IconButton', { size: 'lg' });

      const { isAtBottom, scrollToBottom } = useConversationContext();
      const handleScrollToBottom = useCallback(() => {
        scrollToBottom();
      }, [scrollToBottom]);

      return (
        <chakra.button
          sx={{ ...iconButton, ...scrollButton }}
          onClick={handleScrollToBottom}
          disabled={isAtBottom}
          {...props}
          ref={ref}
        >
          <ArrowLeft transform="rotate(-90deg)" />
        </chakra.button>
      );
    },
  );
ConversationScrollButton.displayName = 'ConversationScrollButton';
